import React from "react";

import { attemptMethod } from "@utils/general";

import ContentBlock from "./contentListBlock.component";

type Props = {
    content: string;
};

const ContentListBlock = ({ content }: Props) => (
    <ContentBlock content={attemptMethod(() => JSON.parse(content), {})} />
);

export { ContentListBlock };
